<template>
  <div id="login">
    <b-container v-if="authenticated">
      <h2>You are logged as {{ userLogin }}.</h2>
      <b-button size="lg" variant="danger" @click="logout">Logout</b-button>
    </b-container>
    <b-container v-else>
      <b-form @submit="login">
        <b-form-group
          id="inputloginGroup"
          label="Please login"
          label-for="inputlogin"
          description="If you are not registred, please contact jean.keller_at_lrsv.ups-tlse.fr"
        >
          <b-form-input
            id="inputlogin"
            v-model="input.login"
            required
            placeholder="Enter login"
            @change="showLoginAlert = false"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="inputPasswordGroup" label label-for="inputPassword">
          <b-form-input
            id="inputPassword"
            v-model="input.password"
            type="password"
            required
            placeholder="Enter password"
            @change="showLoginAlert = false"
          ></b-form-input>
        </b-form-group>
        <b-button type="submit" variant="primary">Submit</b-button>
      </b-form>

      <b-alert
        dismissible
        :show="dismissCountDown"
        :variant="variant"
        @dismissed="dismissCountDown = 0"
        @dismiss-count-down="countDownChanged"
        >{{ messageAlert }}</b-alert
      >
    </b-container>
  </div>
</template>

<script>
import router from '../router';

export default {
  name: 'Login',
  data() {
    return {
      input: {
        login: '',
        password: '',
      },
      status: 'success',
      dismissSecs: 3,
      dismissCountDown: 0,
      messageAlert: '',
      variant: 'success',
    };
  },
  computed: {
    authenticated: function() {
      return this.$store.getters.isLoggedIn;
    },
    userLogin: function() {
      return this.$store.getters.getLogin;
    },
  },
  methods: {
    login(evt) {
      evt.preventDefault();
      const { login, password } = this.input;
      let loader = this.$loading.show({
        // Optional parameters
        container: null,
        canCancel: false,
        loader: 'dots',
      });
      this.$store.dispatch('login', { login, password }).then(
        resp => {
          loader.hide();
          if (resp.body.success === true) {
            router.push('/about');
          } else {
            this.variant = 'danger';
            this.messageAlert = 'Bad password or login';
            this.showAlert();
          }
        },
        () => {
          loader.hide();
          this.variant = 'danger';
          this.messageAlert = 'Server error';
          this.showAlert();
        }
      );
    },
    logout() {
      this.$store.dispatch('logout').then(() => {
        this.variant = 'success';
        this.messageAlert = 'You have been successfully logged out';
        this.showAlert();
      });
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
  },
};
</script>

<style scoped>
#login {
  text-align: left;
  margin: 100px 10px 10px 10px;
}
</style>
